import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, HeartPulseIcon, ShieldCheckIcon, TruckIcon } from 'lucide-react';
import { CATEGORIES, IMAGES, PRODUCTS } from '../data/products';
import { ProductCard } from '../components/ProductCard';
const FEATURED = PRODUCTS.filter(p => p.bestSeller).slice(0, 4);
const PERKS = [{
  icon: TruckIcon,
  title: 'Envío gratis',
  text: 'En compras mayores a $ 3.500 en todo Uruguay.'
}, {
  icon: ShieldCheckIcon,
  title: 'Garantía 12 meses',
  text: 'Cambio sin costo si el material falla.'
}, {
  icon: HeartPulseIcon,
  title: 'Diseño ergonómico',
  text: 'Testeado con entrenadores y fisioterapeutas.'
}];
export function Home() {
  return <div className="w-full bg-black" data-id="element-1025" data-mp="3kvk5ok4kl15z">
      {/* HERO */}
      <section className="relative w-full overflow-hidden bg-black" data-id="element-1026" data-mp="3kv0mz173i8qw">
        <img src={IMAGES.hero} alt="Atleta entrenando con banda elástica ZADAR" className="absolute inset-0 h-full w-full object-cover object-center opacity-70" data-id="element-1027" data-mp="3ovuc1xw9xtld" />
        <div className="absolute inset-0 bg-black/55" data-id="element-1028" data-mp="2vyq964e3me8a" />
        <div className="absolute inset-y-0 left-0 w-full bg-[linear-gradient(90deg,#000000_0%,rgba(0,0,0,0.75)_45%,rgba(0,0,0,0.1)_100%)]" data-id="element-1029" data-mp="2qylos3a2kzcs" />

        <div className="relative mx-auto w-full max-w-7xl px-5 py-24 sm:py-32 lg:px-8 lg:py-40" data-id="element-1030" data-mp="2mvyu7um0l0bw">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease: [0.16, 1, 0.3, 1]
        }} className="max-w-2xl" data-id="element-1031" data-mp="2hyyxiab219xg">
            <span className="inline-flex items-center gap-2 border border-pink-500/40 bg-pink-500/10 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.24em] text-pink-400" data-id="element-1032" data-mp="288nle0h7vufh">
              Hecho en Uruguay
            </span>
            <h1 className="mt-6 font-display text-5xl uppercase leading-[0.9] tracking-tight text-white sm:text-7xl lg:text-8xl" data-id="element-1033" data-mp="1z98w34csdpwk">
              Accesorios fitness que{' '}
              <span className="text-pink-500" data-id="element-1034" data-mp="1kjfindf9p2mb">cuidan tu cuerpo</span>
            </h1>
            <p className="mt-6 font-display text-lg uppercase tracking-[0.22em] text-white/70 sm:text-xl" data-id="element-1035" data-mp="1on3uw9eugmdw">
              Sin dolor <span className="text-teal-500" data-id="element-1036" data-mp="1aodtihkzs0jq">•</span> Sin lesiones{' '}
              <span className="text-teal-500" data-id="element-1037" data-mp="1fmfcz3mby1vq">•</span> Sin incomodidad
            </p>
            <div className="mt-10 flex flex-col gap-3 sm:flex-row" data-id="element-1038" data-mp="23aym1ld7eiov">
              <Link to="/productos" className="inline-flex items-center justify-center gap-2 bg-pink-500 px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-pink-600" data-id="element-1039" data-mp="28abh2te8aw2j">
                Ver productos
                <ArrowRightIcon className="h-4 w-4" data-id="element-1040" data-mp="1yi5i2zpk7edu" />
              </Link>
              <a href="#nosotros" className="inline-flex items-center justify-center border border-white px-8 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors hover:bg-white hover:text-black" data-id="element-1041" data-mp="2m8huonvr1zar">
                Conocer más
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* PERKS */}
      <section aria-label="Beneficios ZADAR" className="border-y border-white/10 bg-ink-900" data-id="element-1042" data-mp="odcfp7e8c87q">
        <div className="mx-auto grid w-full max-w-7xl gap-8 px-5 py-10 sm:grid-cols-3 lg:px-8" data-id="element-1043" data-mp="kewmumvgw5me">
          {PERKS.map(({
          icon: Icon,
          title,
          text
        }) => <div key={title} className="flex items-start gap-4" data-id="element-1044" data-mp="3nuap87xp05kf">
              <Icon className="h-6 w-6 shrink-0 text-pink-500" data-id="element-1045" data-mp="5necp5pah5ay" />
              <div data-id="element-1046" data-mp="5ljn3e32op0j">
                <h3 className="font-display text-lg uppercase tracking-[0.14em] text-white" data-id="element-1047" data-mp="ojiz8ps9wc2">
                  {title}
                </h3>
                <p className="mt-1 text-sm text-white/45" data-id="element-1048" data-mp="1h1rvhw56quk4">{text}</p>
              </div>
            </div>)}
        </div>
      </section>

      {/* CATEGORIES */}
      <section className="mx-auto w-full max-w-7xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-1049" data-mp="27e4yujrjcoan">
        <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-1050" data-mp="27g98lic48hiu">
          <div data-id="element-1051" data-mp="2cd8341zoyqhk">
            <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-pink-500" data-id="element-1052" data-mp="2cesytuxqsfh0">
              Categorías
            </span>
            <h2 className="mt-3 font-display text-4xl uppercase leading-none text-white sm:text-5xl" data-id="element-1053" data-mp="2mbfiigec10hg">
              Elegí tu equipo
            </h2>
          </div>
          <Link to="/productos" className="group inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-white/60 transition-colors hover:text-pink-400" data-id="element-1054" data-mp="2qawn77lxptlk">
            Ver catálogo completo
            <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-1055" data-mp="350c29qc3salf" />
          </Link>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1056" data-mp="3a2kuull2dan0">
          {CATEGORIES.slice(0, 4).map((cat, i) => <motion.div key={cat.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.08
        }} data-id="element-1057" data-mp="12ezx45kfaqy1" data-mpi={i}>
              <Link to={`/productos?cat=${cat.id}`} className="group relative block h-80 overflow-hidden border border-white/10 bg-ink-600 transition-colors hover:border-pink-500" data-id="element-1058" data-mp="tgebu2nkgxtk">
                <img src={cat.image} alt={cat.label} className="absolute inset-0 h-full w-full object-cover opacity-60 transition-all duration-500 group-hover:scale-105 group-hover:opacity-80" data-id="element-1059" data-mp="1h44fpnv4qx6o" />
                <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0.15)_0%,rgba(0,0,0,0.85)_75%)] transition-opacity group-hover:opacity-90" data-id="element-1060" data-mp="17byrmp800zwr" />
                <div className="absolute inset-x-0 bottom-0 p-6" data-id="element-1061" data-mp="201yoc0scj6oj">
                  <h3 className="font-display text-3xl uppercase leading-none text-white transition-colors group-hover:text-pink-400" data-id="element-1062" data-mp="3uaubjwcaatgj">
                    {cat.label}
                  </h3>
                  <p className="mt-2 text-sm text-white/50" data-id="element-1063" data-mp="3kkstbl6m459j">{cat.blurb}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.2em] text-pink-500 opacity-0 transition-opacity duration-300 group-hover:opacity-100" data-id="element-1064" data-mp="3kion2wl8qu63">
                    Ver {cat.count} productos
                    <ArrowRightIcon className="h-3.5 w-3.5" data-id="element-1065" data-mp="3fly86cl6a4m9" />
                  </span>
                </div>
              </Link>
            </motion.div>)}
        </div>
      </section>

      {/* FEATURED PRODUCTS */}
      <section className="border-t border-white/10 bg-ink-900" data-id="element-1066" data-mp="36ljm3b0dwlhp">
        <div className="mx-auto w-full max-w-7xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-1067" data-mp="zu0or3kbon2i">
          <div className="flex flex-wrap items-end justify-between gap-4" data-id="element-1068" data-mp="14tmwwyland4g">
            <div data-id="element-1069" data-mp="14rkaeojco24h">
              <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-teal-500" data-id="element-1070" data-mp="1exlaoepfjlsf">
                Los más vendidos
              </span>
              <h2 className="mt-3 font-display text-4xl uppercase leading-none text-white sm:text-5xl" data-id="element-1071" data-mp="19zs25f0nmfoz">
                Productos destacados
              </h2>
            </div>
            <Link to="/productos" className="group inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.2em] text-white/60 transition-colors hover:text-pink-400" data-id="element-1072" data-mp="1iyx0olc7u915">
              Ver todos
              <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-1073" data-mp="1sr2rvsun8mfa" />
            </Link>
          </div>

          <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1074" data-mp="22mmmmbxh1f2g">
            {FEATURED.map(product => <ProductCard key={product.id} product={product} data-id="element-1075" data-mp="cbrs2t5h4967" />)}
          </div>
        </div>
      </section>

      {/* MOTIVATIONAL BANNER */}
      <section className="relative w-full overflow-hidden bg-black" data-id="element-1076" data-mp="8bhnnkxbxqtg">
        <img src={IMAGES.quote} alt="" aria-hidden className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-1077" data-mp="wtjtjuh4z02a" />
        <div className="absolute inset-0 bg-black/70" data-id="element-1078" data-mp="16jmnbww30i1o" />
        <div className="relative mx-auto max-w-5xl px-5 py-24 text-center lg:py-32" data-id="element-1079" data-mp="16m8v9xmvwzkf">
          <motion.blockquote initial={{
          opacity: 0,
          scale: 0.96
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-1080" data-mp="1ankmg7lepsuq">
            <p className="font-display text-4xl uppercase leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl" data-id="element-1081" data-mp="mvvpgdxn4g7g">
              No existen atajos para
              <br data-id="element-1082" data-mp="rw9ynzaz9w72" />
              alcanzar tus <span className="text-pink-500" data-id="element-1083" data-mp="1yb2hqd3vr92g">sueños</span>
            </p>
            <footer className="mt-8 font-display text-sm uppercase tracking-[0.4em] text-white/40" data-id="element-1084" data-mp="1yaso8fjmmjs0">
              — ZADAR
            </footer>
          </motion.blockquote>
        </div>
      </section>

      {/* ABOUT */}
      <section id="nosotros" className="border-t border-white/10 bg-ink-800 scroll-mt-20" data-id="element-1085" data-mp="28ezf9onsrzrp">
        <div className="mx-auto grid w-full max-w-7xl items-stretch gap-0 lg:grid-cols-2" data-id="element-1086" data-mp="23o0xslr2ovmv">
          <div className="flex flex-col justify-center px-5 py-16 lg:px-12 lg:py-24" data-id="element-1087" data-mp="1zmxh5x17avkl">
            <span className="text-[10px] font-bold uppercase tracking-[0.28em] text-pink-500" data-id="element-1088" data-mp="1zkuqdas84yet">
              Nosotros
            </span>
            <h2 className="mt-3 font-display text-4xl uppercase leading-none text-white sm:text-5xl" data-id="element-1089" data-mp="1po87grjgkhff">
              Entrenar fuerte
              <br data-id="element-1090" data-mp="1kpomatcov9o4" />
              no debería doler
            </h2>
            <p className="mt-6 text-base leading-relaxed text-white/55" data-id="element-1091" data-mp="1gol3pz39azj7">
              ZADAR nació en Montevideo en 2021, cuando dejamos de encontrar
              accesorios que aguantaran nuestro propio entrenamiento. Las bandas
              se enrollaban, los guantes se rompían y las tobilleras lastimaban.
              Así que los rediseñamos desde cero.
            </p>
            <p className="mt-4 text-base leading-relaxed text-white/55" data-id="element-1092" data-mp="8n9okx1ozoh4">
              Cada producto se prueba durante tres meses con entrenadores y
              fisioterapeutas uruguayos antes de salir a la venta. Si no cuida tu
              cuerpo, no lleva nuestro nombre.
            </p>

            <dl className="mt-10 grid grid-cols-3 gap-6 border-t border-white/10 pt-8" data-id="element-1093" data-mp="3q383iwj8oo07">
              {[{
              k: '+12.000',
              v: 'Clientes'
            }, {
              k: '4,8/5',
              v: 'Valoración'
            }, {
              k: '48 h',
              v: 'Entrega MVD'
            }].map(stat => <div key={stat.v} data-id="element-1094" data-mp="3v2kpzg677t29">
                  <dt className="font-display text-3xl leading-none text-pink-500" data-id="element-1095" data-mp="3v2b15vww3ry5">
                    {stat.k}
                  </dt>
                  <dd className="mt-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-white/45" data-id="element-1096" data-mp="37b5kxfn1exnb">
                    {stat.v}
                  </dd>
                </div>)}
            </dl>
          </div>
          <div className="relative min-h-[380px] lg:min-h-[560px]" data-id="element-1097" data-mp="1mmkxkfdwtpkg">
            <img src={IMAGES.about} alt="Atleta descansando entre series con guantes ZADAR" className="absolute inset-0 h-full w-full object-cover" data-id="element-1098" data-mp="1mnw1qgb9ozc3" />
          </div>
        </div>
      </section>
    </div>;
}